import React, { useEffect, useState } from "react";
import { Wallet as WalletIcon, Loader2, ArrowDownLeft, ArrowUpRight, Landmark, Plus } from "lucide-react";
import { toast } from "sonner";
import { api, local } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Wallet() {
  const [email, setEmail] = useState(local.getEmail());
  const [data, setData] = useState(null);
  const [amount, setAmount] = useState("");
  const [pay, setPay] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async (e) => {
    if (!e) return;
    try { setData(await api.wallet(e)); } catch (err) { setData(null); }
  };
  useEffect(() => { api.paymentInfo().then(setPay); if (email) load(email); }, []);

  const topup = async () => {
    const amt = parseFloat(amount);
    if (!email.trim() || !amt || amt <= 0) { toast.error("أدخل البريد ومبلغًا صحيحًا"); return; }
    setLoading(true);
    try {
      local.setEmail(email);
      const order = await api.walletTopup({ kind: "wallet_topup", amount: amt, method: "bank", email, name: email });
      toast.success(`تم إنشاء طلب شحن ${amt} ريال — حوّل المبلغ ثم ينتظر اعتماد الإدارة (${order.reference})`);
      setAmount("");
      load(email);
    } catch (e) { toast.error("تعذّر إنشاء الطلب"); }
    setLoading(false);
  };

  return (
    <main className="relative min-h-screen pt-32">
      <div className="absolute left-1/2 top-24 h-64 w-[700px] -translate-x-1/2 hero-glow blur-3xl" />
      <section className="relative mx-auto max-w-3xl px-5 lg:px-8">
        <div className="flex items-center gap-2 text-white">
          <WalletIcon className="h-6 w-6 text-cyan" />
          <h1 className="font-display text-3xl font-extrabold">المحفظة</h1>
        </div>
        <p className="mt-1 text-sm text-muted-foreground">اشحن رصيدك وادفع للباقات والخدمات مباشرةً.</p>

        <div className="mt-6 flex gap-2">
          <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="بريدك الإلكتروني" className="border-white/10 bg-white/5 text-white" dir="ltr" />
          <Button onClick={() => { local.setEmail(email); load(email); }} className="btn-cyan rounded-lg px-5 font-semibold hover:bg-transparent">عرض</Button>
        </div>

        <div className="mt-6 rounded-3xl border border-cyan/25 bg-gradient-to-br from-cyan-500/10 to-transparent p-8 text-center">
          <p className="text-sm text-muted-foreground">الرصيد الحالي</p>
          <div className="mt-2 font-display text-5xl font-extrabold text-white">
            {data ? data.balance : 0} <span className="text-2xl text-cyan">ريال</span>
          </div>
        </div>

        <div className="mt-6 rounded-2xl border border-white/10 bg-white/[0.02] p-6">
          <h3 className="flex items-center gap-2 font-display font-bold text-white"><Plus className="h-5 w-5 text-cyan" /> شحن الرصيد (تحويل بنكي)</h3>
          <div className="mt-3 flex gap-2">
            <Input value={amount} onChange={(e) => setAmount(e.target.value)} type="number" placeholder="المبلغ بالريال" className="border-white/10 bg-white/5 text-right text-white" />
            <Button onClick={topup} disabled={loading} className="btn-gold gap-2 rounded-lg px-5 font-semibold hover:bg-transparent">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Landmark className="h-4 w-4" />} شحن</Button>
          </div>
          {pay && <p className="mt-3 text-xs text-muted-foreground">حوّل إلى {pay.bank_name} — IBAN: <span className="font-en text-cyan" dir="ltr">{pay.bank_iban}</span> ثم أرسل الإيصال عبر واتساب.</p>}
        </div>

        <div className="mt-6">
          <h3 className="mb-3 font-display font-bold text-white">سجل العمليات</h3>
          <div className="space-y-2">
            {data?.transactions?.length ? data.transactions.map((t) => (
              <div key={t.id} className="flex items-center justify-between rounded-xl border border-white/10 bg-white/[0.02] px-4 py-3">
                <div className="flex items-center gap-3">
                  <span className={`flex h-9 w-9 items-center justify-center rounded-lg ${t.amount >= 0 ? "bg-emerald-400/10 text-emerald-400" : "bg-rose-400/10 text-rose-400"}`}>
                    {t.amount >= 0 ? <ArrowDownLeft className="h-4 w-4" /> : <ArrowUpRight className="h-4 w-4" />}
                  </span>
                  <div><p className="text-sm text-white">{t.note}</p><p className="text-xs text-muted-foreground">{new Date(t.createdAt).toLocaleString("ar-SA")}</p></div>
                </div>
                <span className={`font-display font-bold ${t.amount >= 0 ? "text-emerald-400" : "text-rose-400"}`}>{t.amount >= 0 ? "+" : ""}{t.amount}</span>
              </div>
            )) : <p className="rounded-xl border border-dashed border-white/10 py-10 text-center text-sm text-muted-foreground">لا توجد عمليات بعد.</p>}
          </div>
        </div>
      </section>
      <div className="h-20" />
    </main>
  );
}
